import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import LocationsController from "@/modules/locations/LocationsController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

export default function Locations() {
  const canViewLocations = useHasPermission(Permission.LOCATIONS_VIEW);

  if (!canViewLocations) {
    return (
      <AccessRestricted
        breadcrumbs={[
          { label: "Records" },
          { label: "Locations", current: true },
        ]}
        message="You do not have permission to view locations."
      />
    );
  }

  return (
    <Layout
      breadcrumbs={[{ label: "Locations", current: true }]}
      className="h-full"
    >
      <LocationsController />
    </Layout>
  );
}
